import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { PORTFOLIO_STALE_TIME } from "@/api/portfolio-query";
import { client } from "./client";

type OverviewRange = { from: string; to: string };

export const useOverview = (range: OverviewRange, workspaceId?: string) =>
  useQuery({
    queryKey: ["portfolio-overview", workspaceId ?? null, range.from, range.to],
    queryFn: async () => {
      const query = { from: range.from, to: range.to };
      const res = workspaceId
        ? await client.workspace[":workspaceId"].portfolio.overview.$get({ param: { workspaceId }, query })
        : await client.portfolio.overview.$get({ query });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    staleTime: PORTFOLIO_STALE_TIME,
  });

export const useOverviewActiveCreators = (range: OverviewRange, merchantIds: string[] | null, workspaceId?: string) =>
  useQuery({
    queryKey: ["portfolio-overview-active-creators", workspaceId ?? null, range.from, range.to, merchantIds],
    queryFn: async () => {
      const query = { from: range.from, to: range.to, ...(merchantIds && { merchantId: merchantIds }) };
      const res = workspaceId
        ? await client.workspace[":workspaceId"].portfolio.overview["active-creators"].$get({
            param: { workspaceId },
            query,
          })
        : await client.portfolio.overview["active-creators"].$get({ query });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    staleTime: PORTFOLIO_STALE_TIME,
  });
